module.exports = __webpack_public_path__ + "static/media/mas-sigit.8c823861.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/mas-sigit.gif
// module id = 43
// module chunks = 0